import { Button } from '@ordr-as/umami-react/button';
import { Dialog } from '@ordr-as/umami-react/dialog';
import type { FC } from 'react';

interface Props {
  label: string;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmPaymentDialog: FC<Props> = ({ label, onClose, onConfirm }) => (
  <Dialog
    className="w-full mx-4 tablet:w-1/2 tablet:mx-0"
    title={`Are you sure you want to pay with ${label}?`}
    onClose={onClose}
  >
    <div className="flex justify-center p-3 border-b border-b-grey-lightest w-full gap-4">
      <Button className="w-1/2" kind="secondary" onClick={onClose}>
        No
      </Button>
      <Button className="w-1/2" kind="primary" onClick={onConfirm}>
        Yes
      </Button>
    </div>
  </Dialog>
);

export default ConfirmPaymentDialog;
